<template>
    <v-card>
        <v-card-title class="accent white--text title">
          {{this.title|translate}}
        </v-card-title>
        <v-card-text v-if="loading">
            <loading-progress-bar :loading="loading"></loading-progress-bar>
        </v-card-text>
        <v-card-text v-if="!loading">
            <v-layout>
                <v-flex xs12>
                    <vue-plotly :white-mode="whiteMode" :data="data" :layout="layout" :options="options" ref="plotly"/>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import LoadingProgressBar from '@/components/LoadingProgressBar'
import {getResult} from '@/helper'
import {mapGetters} from 'vuex'
  export default {
    props:{
        title: {type: String, default: 'Latest Cooling Load Forecast'},
        yTitle: {type: String, default: 'Cooling Load (kWh)'},
        xTitle: {type: String, default: 'Time'},
        minPower: {type: Number, default: 0},
        expectedValueLegend: {type: String, default: 'Expected Value'},
        fittedValueLegend: {type: String, default: 'Fitted Value'},
        actualObservedValueLegend: {type: String, default: 'Actual Observed Value'},
        confidenceIntervalLegend: {type: String, default: '95% Confidence Interval'},
        resultName: {type: String, default: 'cooling load'},
        whiteMode:{type:Boolean, default: false},
    },
    name: 'CoolingLoadForecastWidget',
    components: {LoadingProgressBar, VuePlotly},
    data () {
      return {
        loading: true,
        data: null,
        options: {},
      }
    },
    computed: {
        ...mapGetters([
            'coolingLoadUnit',
        ]),
      layout () {
        return {
          hovermode: 'closest',
          xaxis: {
            title: this.$options.filters.translate(this.xTitle),
            range: [this.dateStart, this.dateEnd],
          },
          yaxis: {
            title: this.$options.filters.translate(this.yTitle)
          },
            legend: {
                orientation: 'h',
                traceorder:'normal',
                y:-0.2
            },
            showlegend:true,
            hoverlabel: {
                namelength: -1,
            },
            margin:{
                l: 50,
                r: 50,
                t: 30,
                pad: 1
            },
        }
      }
    },
    beforeMount () {
      this.refresh()
    },
    methods: {
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async refresh () {
        let result = await getResult({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
          result_name: this.resultName
        })

        if (result['result'].length==0) {
          // no cooling load prediction result
          return null
        }


        let actualdata = result['result'][0]['content']['df']
        let newdata = result['result'][0]['content']['forecast']

        let cutpoint = actualdata.timestamp.length
        let endpoint = newdata.timestamp.length

        this.startDate = actualdata.timestamp[cutpoint-24*4*14]
        this.endDate = newdata.timestamp[cutpoint+24*4*2]


        this.data = [
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 0.1,
              opacity: 0.1
            },
            name: this.confidenceIntervalLegend,
            x: newdata.timestamp,
            y: newdata.yhat_lower,
            type: 'scatter',
            mode: 'lines',
            showlegend: false
          },
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 0.1,
              opacity: 0.1
            },
            name: this.confidenceIntervalLegend,
            x: newdata.timestamp,
            y: newdata.yhat_upper,
            type: 'scatter',
            mode: 'lines',
            fill: 'tonexty'
          },

          {
            marker: {
              color: 'rgb(0,0,0)',
              opacity: 0.3
            },
            x: actualdata.timestamp,
            y: actualdata.total_CL,
            name: this.actualObservedValueLegend,
            type: 'scatter',
            mode: 'markers'
          },
          {
            line: {
              color: 'rgb(0,76,255)',
              shape: 'spline',
              width: 1,
              opacity: 0.9
            },
            x: newdata.timestamp.slice(0, cutpoint),
            y: newdata.yhat.slice(0, cutpoint),
            name: this.fittedValueLegend,
            type: 'scatter',
            mode: 'lines'
          },
          {
            line: {
              color: 'rgb(255,76,76)',
              shape: 'spline',
              width: 1,
              opacity: 0.9
            },
            x: newdata.timestamp.slice(cutpoint-1, endpoint),
            y: newdata.yhat.slice(cutpoint-1, endpoint),
            name: this.expectedValueLegend,
            type: 'scatter',
            mode: 'lines'
          },
          ]
        this.loading=false
      }
    }

  }
</script>

<style scoped>

</style>
